/**
 * The head id, restated every send. The signal is whether it changed; the
 * prompt says what that means. Model-facing, like every part here.
 */

import type { TextPart } from "ai";

export interface CheckpointHeadPart {
  id: string;
}

export const convertCheckpoints = ({ id }: CheckpointHeadPart): TextPart => ({
  type: "text",
  text: `Current head: ${id}`,
});
